import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustStrip from "@/components/site/TrustStrip";
import Services from "@/components/site/Services";
import InvestIndia from "@/components/site/InvestIndia";
import About from "@/components/site/About";
import WhyUs from "@/components/site/WhyUs";
import Team from "@/components/site/Team";
import Insights from "@/components/site/Insights";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-[#FDFBF7] text-[#1B3B2B]">
      <Header />
      <Hero />
      <TrustStrip />
      <Services />
      <InvestIndia />
      <About />
      <WhyUs />
      <Team />
      <Insights />
      <Contact />
      <Footer />
    </main>
  );
}
